export const SANCTION_TYPES = {
  SUSPENSION: "SUSPENSION",
  SUPPRESSION: "SUPPRESSION",
};

export const MAIN_REASONS = {
  REFUS_ELABORER_ACTUALISER_CONTRAT: {
    id: "REFUS_ELABORER_ACTUALISER_CONTRAT",
    label: "Refus d'élaborer ou d'actualiser le contrat",
    requiresSDD: true,
    allowedForSuspension: true,
    allowedForSuppression: true,
  },
  NON_RESPECT_DISPOSITIONS_CONTRAT: {
    id: "NON_RESPECT_DISPOSITIONS_CONTRAT",
    label: "Non-respect des dispositions au contrat",
    requiresSDD: true,
    allowedForSuspension: true,
    allowedForSuppression: true,
  },
  REFUS_OFFRE_RAISONNABLE_EMPLOI: {
    id: "REFUS_OFFRE_RAISONNABLE_EMPLOI",
    label:
      "Non-respect des dispositions au contrat constitué par le refus à deux reprises sans motif légitime d’une offre raisonnable d’emploi.",
    requiresSDD: true,
    requiresPathType: true,
    notAllowedForSocialPath: true,
    allowedForSuspension: true,
    allowedForSuppression: true,
  },
  REFUS_SOUMETTRE_CONTROLES: {
    id: "REFUS_SOUMETTRE_CONTROLES",
    label: "Refus de se soumettre aux contrôles",
    requiresSDD: false,
    allowedForSuspension: false,
    allowedForSuppression: true,
  },
};

export const PATH_TYPES = {
  SOCIAL: {
    id: "SOCIAL",
    label: "Social",
  },
  PROFESSIONNEL: {
    id: "PROFESSIONNEL",
    label: "Professionnel",
  },
  SOCIO_PROFESSIONNEL: {
    id: "SOCIOPROFESSIONEL",
    label: "Socio-professionnel",
  },
};

export const DETECTION_TYPES = {
  PREMIER: "PREMIER",
  PERSISTANCE: "PERSISTANCE",
  REITERATION: "REITERATION",
};

export const PROPOSAL_TYPES = {
  DEFAUT: {
    id: "DEFAUT",
    label: "Proposition par défaut",
  },
  MODEREE: {
    id: "MODEREE",
    label: "Sanction modérée",
  },
  AUCUNE_SANCTION: {
    id: "AUCUNE_SANCTION",
    label: "Aucune sanction",
  },
};
